import React from 'react';
import { Routes, Route, BrowserRouter } from 'react-router-dom';
import { authProtectedRoutes, publicRoutes } from './routes';
// import AuthMiddleware from './routes/AuthMiddleware';
import Layout from './components/Layout';
import RegistrationCheckMiddleware from './routes/RegisterCheckMiddleware';

interface RouteConfig {
  path: string;
  component: React.ReactNode;
}

const App: React.FC = () => {

  return (
    <>
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          {publicRoutes.map((route: RouteConfig, idx: number) => (
            <Route
              path={route.path}
              element={route.component}
              key={idx}
            />
          ))}

          {/* Auth Protected Routes */}
          {authProtectedRoutes.map((route: RouteConfig, idx: number) => (
            <Route
              path={route.path}
              element={
                // <AuthMiddleware>
                <RegistrationCheckMiddleware>
                  <Layout>
                    {route.component}
                  </Layout>
                </RegistrationCheckMiddleware>
                // </AuthMiddleware>
              }
              key={idx}
            />
          ))}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
